import { render, staticRenderFns } from "./detail_pickup.vue?vue&type=template&id=235e7946&scoped=true&"
import script from "./detail_pickup.vue?vue&type=script&lang=js&"
export * from "./detail_pickup.vue?vue&type=script&lang=js&"
import style0 from "./detail_pickup.vue?vue&type=style&index=0&id=235e7946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e7946",
  null
  
)

export default component.exports